import styles from "./OnboardingStyles.module.css"
import { useState } from 'react';
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import SecondaryButton from "../Button/SecondaryButton/SecondaryButton";
import { StepFormProps } from "../../types/onboarding.types";
import PrimaryInput from "../Input/PrimaryInput/PrimaryInput";
import OnboardingPopup from "./OnboardingPopup";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useTranslation } from "react-i18next";
/**
* Onboarding step.
*
* @param props StepFormProps
* @param {(step: number) => void} props.setStep - Step change handler
* @param {number} props.currentStep - Current step
* @param {OnboardingFormData} props.formData - Onboarding data
* @param {React.Dispatch<React.SetStateAction<OnboardingFormData>>} props.setFormData - Onboarding data change handler
* @param {() => void} props.clearData - Clear data handler
* @returns TSX.Element
*/
const Step2Form = ({currentStep, setStep, formData, setFormData, onPopup}:StepFormProps) => {
    const { t } = useTranslation(); // Translation
    const windowSize = useWindowSize(); // Window size
    const [amountOfPeople, setAmountOfPeople] = useState<number | undefined>(formData.peopleAmount ?? undefined); // Current amount of people
    const [popupOpen, setPopupOpen] = useState<boolean>(false) // Popup display state
    
    const handleLargeAction = () => {
        // redirect to email or smth
        alert("vytvorena poptavka")
    };
    
    // Amount of people submit logic
    const handleAction = () => {
        if(amountOfPeople && amountOfPeople > 30){
            setPopupOpen(true)
        }else{
            setFormData((prev: typeof formData) => ({ ...prev, peopleAmount: Number(amountOfPeople) }))
            setStep(currentStep+1)
        }
    }
    
    return(
        <>
        {/*Large action popup */}
        <OnboardingPopup
            titleKey="onboarding.steps.2.popup.title"
            contentKey="onboarding.steps.2.popup.content"
            display={popupOpen}
            onClose={() => setPopupOpen(false)}
            onSubmit={() => handleLargeAction()}
            onPopup={onPopup}
        />
        <div className={styles.OnboardingContent}>
            <div className={styles.Container}>
                <div className={styles.SecondaryTitle}>
                    <p>{t("onboarding.steps.2.title")}</p>
                </div>
                <div className={styles.ActionButtons2}>
                    <SecondaryButton onClick={()=>setPopupOpen(true)} text={t("onboarding.steps.2.buttons.more_than_30")} className={styles.WideSecondaryButton} showChevron={false} colorVariant="primary"/>
                    {windowSize > 900 ? (
                        <>
                        <PrimaryInput
                            className={styles.Input}
                            placeholder={t("onboarding.steps.2.buttons.custom")}
                            type="number"
                            onChange={(value) => setAmountOfPeople(Number(value))}
                            value={amountOfPeople}
                            min={1}
                            max={30}
                    />
                        </>
                    ):(
                        <>
                        <PrimaryInput
                            className={styles.Input}
                            placeholder={t("inputs.amount")}
                            type="number"
                            onChange={(value) => setAmountOfPeople(Number(value))}
                            value={amountOfPeople}
                            min={1}
                            max={30}
                        />
                        </>
                    )}
                </div>
                <div  className={styles.ContinueButton}>
                    <div className={styles.ContinueChoice} onClick={()=>setStep(currentStep+1)}><p></p></div>
                    <PrimaryButton onClick={()=>handleAction()} text={t("buttons.proceed")}/>
                </div>
            </div>
        </div>
        </>
    )
};

export default Step2Form;
